import { IApiRequest, IApiResponse, IAutoTriggerFlow } from "@miplatform/types";
import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_AUTO_TRIGGER_FLOWS = `${TASK_SERVICE}/auto-trigger-flows`;

export const autoTriggerFlows = {
  getAll: async ({ filters, sort, top, skip }: IApiRequest = {}): Promise<
    IApiResponse<IAutoTriggerFlow[]>
  > => {
    const options = await apiOptions({
      filters,
      sort,
      top,
      skip,
      url: API_AUTO_TRIGGER_FLOWS,
    });

    return apiRequest(options);
  },
  getById: async ({
    id,
  }: {
    id: string;
  }): Promise<IApiResponse<IAutoTriggerFlow>> => {
    const options = await apiOptions({
      url: `${API_AUTO_TRIGGER_FLOWS}/${id}`,
    });

    return apiRequest(options);
  },
  create: async ({
    data,
    toastMessageConfig,
  }: IApiRequest): Promise<IApiResponse<IAutoTriggerFlow>> => {
    const options = await apiOptions({
      url: API_AUTO_TRIGGER_FLOWS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  update: async ({
    id,
    data,
    modifiedOn,
    toastMessageConfig,
  }: IApiRequest): Promise<IApiResponse<IAutoTriggerFlow>> => {
    const options = await apiOptions({
      url: `${API_AUTO_TRIGGER_FLOWS}/${id}`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION, "if-match": modifiedOn },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_AUTO_TRIGGER_FLOWS}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: {
        modifiedOn,
      },
    });
    return apiRequest(options, toastMessageConfig);
  },
  disableBuilder: async ({
    id,
    builderId,
    data,
    modifiedOn,
    toastMessageConfig,
  }: IApiRequest & { builderId: string }): Promise<
    IApiResponse<IAutoTriggerFlow>
  > => {
    const options = await apiOptions({
      url: `${API_AUTO_TRIGGER_FLOWS}/${id}/disable-builders/${builderId}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION, "if-match": modifiedOn },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  enableBuilder: async ({
    id,
    builderId,
    data,
    modifiedOn,
    toastMessageConfig,
  }: IApiRequest & { builderId: string }): Promise<
    IApiResponse<IAutoTriggerFlow>
  > => {
    const options = await apiOptions({
      url: `${API_AUTO_TRIGGER_FLOWS}/${id}/enable-builders/${builderId}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION, "if-match": modifiedOn },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
};
